import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/pages/home/about-company/AboutCompany.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/pages/home/connecting-quality/Values.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/(site)/_components/utils/button-cta/ButtonCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/utils/hero-btn/HeroBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/utils/news-card/NewsCard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/(site)/_components/utils/our-products-or-service/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/_components/utils/testimonial/TestimonialSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
